<template>
  <div
    id="emarsysForm"
    class="mb-8 grid gap-4 mobile:grid-cols-1"
    :class="{ 'desktop:grid-flow-col': form1 }"
  >
    <EditableArea
      v-if="form1"
      class="desktop:col-span-1"
      :content="form1"
    />
    <div class="rounded border border-neutral-100 p-6 mobile:px-4 desktop:col-span-2">
      <EditableArea
        v-if="form2"
        :content="form2"
      />
      <form
        autocomplete="off"
        @submit.prevent="onSendEmail"
      >
        <KikDynamicForm
          ref="dynamicForm"
          :key="formKey"
          :values="form"
          :fields="fields"
          @on-form-update="onFormUpdate"
        >
          <div>
            <EditableArea
              v-if="form3"
              class="mb-4 font-light"
              :content="form3"
            />
            <KikButton
              class="min-w-40 mobile:min-w-full"
              :disabled="errors || loading"
              v-bind="{ type: 'submit' }"
            >
              <SfLoaderCircular v-if="loading" />
              <span v-else>{{ switchable?.btnLabel }}</span>
            </KikButton>
          </div>
        </KikDynamicForm>
      </form>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';
import { SfLoaderCircular } from '@storefront-ui/vue';
import { useForm } from '~/composables/custom/useForm/useForm';
import { useTracking } from '~/composables/custom/useTracking';
import { Props } from './Form.model';

const {
  form3,
  form2,
  form1,
  switchable,
} = defineProps(Props);

const route = useRoute();

const { loading, sendEmail, errors } = useForm();
const { trackError } = useTracking();
const dynamicForm = ref();
const formKey = ref(0);

const form: any = ref({});

// removed unused formTag

const onSendEmail = async () => {
  if (dynamicForm.value.isInvalid()) {
    const errors = dynamicForm.value.errors();
    Object.entries<string>(errors).forEach(([key, value]) => {
      trackError(`Form input - my account address - ${key}`, value);
    });
    return;
  }

  const success = await sendEmail({
    ...form.value,
    path: route.path,
  });

  if (success) {
    dynamicForm.value.clearForm();
    form.value = {};
    formKey.value++;
  }
};

const onFormUpdate = (value: unknown) => {
  form.value = value;
};

const fields = computed(() => ({
  'salutation': {
    type: 'option',
    value: switchable?.salutationOptions?.map(key => ({ key, label: key })) || [],
    rules: 'required',
    label: 'Salutation',
  },
  'name': {
    type: 'text',
    label: 'Name',
    rules: 'required',
  },
  'email': {
    type: 'text',
    label: 'E-mail address',
    rules: 'required|minmax:2,50|email',
    onChange: 'trim',
  },
  'subject': {
    label: 'Subject',
    type: 'option',
    value: switchable?.subjectOptions?.map((option) => {
      return {
        ...option,
        key: option.label,
      };
    }) || [],
  },
  'orderNumber': {
    type: 'text',
    label: 'Order number',
    onChange: 'number',
  },
  'add.subject': {
    type: 'text',
    label: 'Other topics',
  },
  'message': {
    type: 'textArea',
    rules: 'required',
    label: 'Message',
  },
}));
</script>
